
document.addEventListener('DOMContentLoaded', () => {
  const recap = document.querySelector('.cart__recap');
  if (!recap) return;

  const headersJSON = { 'Content-Type': 'application/json' };

  // 1) Recupero lista gift id (preferisci la lista finale calcolata server-side)
  const giftIdList =
    (recap.dataset.giftIds && recap.dataset.giftIds.trim()) ||
    (recap.dataset.atcItemVariantToAdd && recap.dataset.atcItemVariantToAdd.trim()) ||
    '';

  const giftIds = giftIdList
    .split(',')
    .map(s => parseInt(s, 10))
    .filter(Boolean);

  if (!giftIds.length) return; // nessun gift configurato

  // 2) Threshold opzionale (se esiste e ha senso)
  const toCents = (s) => {
    if (!s) return 0;
    const n = parseFloat(String(s).replace(',', '.'));
    return Math.round(isNaN(n) ? 0 : n * 100);
  };
  const thresholdCents = toCents(recap.dataset.atcItemThresholdValue || '0');

  const checkoutBtn = document.querySelector('.cart__checkout-button');

  // 3) Controlla il carrello e applica le regole di rimozione
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const items = cart.items || [];
      const isGift = (it) => giftIds.includes(it.variant_id);

      const gifts   = items.filter(isGift);
      const nonGift = items.filter(it => !isGift(it));

      // CASE A: sono rimasti solo gift → rimuovi subito (evita checkout a 0€)
      if (gifts.length && nonGift.length === 0) {
        checkoutBtn?.setAttribute('disabled', 'disabled');
        Promise.all(
          gifts.map(it =>
            fetch('/cart/change.js', {
              method: 'POST',
              headers: headersJSON,
              body: JSON.stringify({ id: it.key, quantity: 0 })
            })
          )
        ).then(() => location.reload());
        return;
      }

      // CASE B: c'è una soglia € e il subtotale (ESCLUSI i gift) scende sotto soglia → togli i gift
      if (thresholdCents > 0 && gifts.length) {
        const subtotalCents = nonGift.reduce((s, it) => s + (it.final_line_price || 0), 0);
        if (subtotalCents < thresholdCents) {
          checkoutBtn?.setAttribute('disabled', 'disabled');
          Promise.all(
            gifts.map(it =>
              fetch('/cart/change.js', {
                method: 'POST',
                headers: headersJSON,
                body: JSON.stringify({ id: it.key, quantity: 0 })
              })
            )
          ).then(() => location.reload());
        }
      }
    })
    .catch(() => { /* no-op: in caso di errore non bloccare la pagina */ });
});